import './panel.scss';
import React, { PureComponent } from 'react';

class Panel extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { expanded, className } = this.props;
        return (
            <div data-testid="panel" className={`lkpanel ${className || ''}`}>
                <div className={`collapse ${expanded ? 'in' : ''}`}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Panel;
